// Campus photo for /colleges/utah-state-university: CC BY-SA 4.0, by Daver1956, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUtah_State_University%2C_Old_Main_Building.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/utah-state-university/; credited under the photo.
const photo = {
    "slug": "utah-state-university",
    "alt": "Old Main and its bell tower at Utah State University in Logan, Utah",
    "src": "/colleges/utah-state-university/campus-1600.webp",
    "srcSmall": "/colleges/utah-state-university/campus-800.webp",
    "srcMid": "/colleges/utah-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/utah-state-university/og.jpg",
    "title": "Utah State University, Old Main Building",
    "author": "Daver1956",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUtah_State_University%2C_Old_Main_Building.jpg",
    "read": "2026-10-01"
};

export default photo;
